import { useId } from "react";

interface WaveformProps {
  level: number;
  active: boolean;
}

const buildPath = (level: number, phase: number, amplitude: number): string => {
  const points: string[] = [];
  for (let index = 0; index <= 72; index += 1) {
    const x = (index / 72) * 1000;
    const envelope = Math.sin((index / 72) * Math.PI) ** 0.7;
    const signal = Math.sin(index * 0.64 + phase) * 0.54 + Math.sin(index * 1.31 - phase) * 0.23;
    const y = 90 + signal * envelope * amplitude * (10 + level * 72);
    points.push(`${index === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`);
  }
  return points.join(" ");
};

export function Waveform({ level, active }: WaveformProps) {
  const titleId = useId();
  const energy = active ? Math.max(0.05, level) : 0.015;
  return (
    <svg className="waveform" viewBox="0 0 1000 180" role="img" aria-labelledby={titleId} preserveAspectRatio="none">
      <title id={titleId}>{active ? "Live microphone waveform" : "Microphone idle"}</title>
      <path className="waveform__guide" d="M0 90 H1000" />
      <path className="waveform__echo" d={buildPath(energy, 1.8, 0.62)} />
      <path className="waveform__signal" d={buildPath(energy, 0, 1)} />
    </svg>
  );
}

